import { Component, Input } from '@angular/core';

@Component({
  selector: 'bn-account-details-certificates-deposit',
  templateUrl: './account-details-certificates-deposit.component.html',
})
export class BnAccountDetailsCertificatesDepositComponent {
  @Input() product: any = {};
  @Input() productNumberFormat: any = {};
  @Input() hostRef: any = {};

  title1 = $localize`:@@product-details.h2.accountDetails:Account Detail`;
  title2 = $localize`:@@product-details.h2.details:Details`;
  title3 = $localize`:@@product-details.h2.otherInfo:Other information`;
}
